import React from "react";
import { get } from "lodash";
import style from "./style.css";

const LoginDisclaimer = (props) => (
  <div className={style.loginResponsibly}>
    {get(props, "cmsMsgs.LoginAware") ||
      "AWARE – Always Wager Responsibly National Problem Gambling Helpline 1-800-MY-RESET."}{" "}
    Must be 21 years of age or older. Residency restrictions apply. Void where
    prohibited.
  </div>
);

export default LoginDisclaimer;
